export default __webpack_public_path__ + "static/cover-17-c7a5d75a4523627210358ae8e52bafad.jpg";